export default {
  'paymentFraudControl.APPROVE': 'Approve',
  'paymentFraudControl.PAY': 'Pay',
  'paymentFraudControl.PAY_AND_ISSUE': 'Pay + Add Issue',
  'paymentFraudControl.PAY_AS_ISSUED': 'Pay as Issued',
  'paymentFraudControl.REJECT': 'Reject',
  'paymentFraudControl.RETURN': 'Return',

  'paymentFraudControl.header': 'Payment Fraud Control Summary',
  'paymentFraudControl.submitted': 'Your disposition(s) have been submitted for processing.',
  'paymentFraudControl.awaitingApproval':
    'Your disposition(s) have been submitted for processing and (<%=pendingApprovals %>) are awaiting approval.',
  'paymentFraudControl.error': 'Action failed to complete.',

  'paymentFraudControl.APPROVE.error': '"Approve" actions failed to complete.',
  'paymentFraudControl.PAY.error': '"Pay" actions failed to complete.',
  'paymentFraudControl.PAY_AND_ISSUE.error': '"Pay + Add Issue" actions failed to complete.',
  'paymentFraudControl.PAY_AS_ISSUED.error': '"Pay as Issued" actions failed to complete.',
  'paymentFraudControl.REJECT.error': '"Reject" actions failed to complete.',
  'paymentFraudControl.RETURN.error': '"Return" actions failed to complete.',

  'paymentFraudControl.APPROVE.success': '"Approve" actions completed.',
  'paymentFraudControl.PAY.success': '"Pay" actions completed.',
  'paymentFraudControl.PAY_AND_ISSUE.success': '"Pay + Add Issue" actions completed.',
  'paymentFraudControl.PAY_AS_ISSUED.success': '"Pay as Issued" actions completed.',
  'paymentFraudControl.REJECT.success': '"Reject" actions completed.',
  'paymentFraudControl.RETURN.success': '"Return" actions completed.',

  'paymentFraudControl.header.APPROVE': 'Approve Exception Items',
  'paymentFraudControl.header.PAY': 'Pay Exception Items',
  'paymentFraudControl.header.PAY_AND_ISSUE': 'Pay + Add Issue Exception Items',
  'paymentFraudControl.header.PAY_AS_ISSUED': 'Pay as Issued Exception Items',
  'paymentFraudControl.header.REJECT': 'Reject Exception Items',
  'paymentFraudControl.header.RETURN': 'Return Exception Items',

  'paymentFraudControl.heading1.APPROVE':
    'You are deciding to Approve the following exception items:',
  'paymentFraudControl.heading1.PAY': 'You are deciding to Pay the following exception items:',
  'paymentFraudControl.heading1.PAY_AND_ISSUE':
    'You are deciding to Pay + Add Issue the following exception items:',
  'paymentFraudControl.heading1.PAY_AS_ISSUED':
    'You are deciding to Pay as Issued the following exception items:',
  'paymentFraudControl.heading1.REJECT':
    'You are deciding to Reject the following exception items:',
  'paymentFraudControl.heading1.RETURN':
    'You are deciding to Return the following exception items:',

  'paymentFraudControl.error.ACTION_DENIED_FOR_PAY_AND_ISSUE':
    'Item is not eligible for Pay + Add Issue decision',
  'paymentFraudControl.error.ACTION_DENIED': 'Item has already been dispositioned',
  'paymentFraudControl.error.NO_ACTION_TAKEN':
    'No actions were taken as there is no change in Disposition Status'
};
